import config from "../settings/config";
import { toErrorText } from "./errorText";
import { getAuthToken } from "./authStorage";

const baseUrl = () => config.env[config.env.mode].url;

/**
 * Sends a 4-digit OTP to the given email address. Reuses the guest endpoint
 * (no auth required) that the login screen already uses.
 */
export const sendRealEmailOtp = async (email) => {
  const res = await fetch(`${baseUrl()}/api/v1/otp/email/send`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
    },
    body: JSON.stringify({ email }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(toErrorText(data, "Errore durante l'invio del codice."));
  }
};

/**
 * Verifies the OTP and persists the real (deliverable) email onto the current
 * authenticated account. On success the backend clears `needs_real_email`, so a
 * subsequent profile refresh dismisses the gate.
 */
export const setVerifiedRealEmail = async (email, code) => {
  const res = await fetch(`${baseUrl()}/api/v1/account/set-verified-email`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${getAuthToken() || ""}`,
    },
    body: JSON.stringify({ email, code }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(toErrorText(data, "Codice non valido o scaduto."));
  }
  return data;
};

/**
 * Recover an existing account ("Recupera il mio account") for a user who just
 * signed in with Apple "Hide My Email". Called while authenticated as the fresh
 * relay account; verifies ownership of the previously-used real email via OTP,
 * links the Apple identity onto the existing account and returns its bearer.
 * Throws with a readable message for the not-found / already-linked cases.
 */
export const linkSocialAccount = async (email, code) => {
  const res = await fetch(`${baseUrl()}/api/v1/account/link-social`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${getAuthToken() || ""}`,
    },
    body: JSON.stringify({ email, code }),
  });

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(toErrorText(data, "Impossibile recuperare l'account."));
  }
  return data; // { token }
};
